// Port of api/fuel/app/classes/filter/search/users/filters/query/text.php
export default {
	name: 'user.text',
	priority: 10,
	require: function(config, filter) { return filter.text && filter.text.length > 0 },
	run: function(config, filter, data, query) {
		var text = filter.text.toLowerCase()
		query.whereGroup('OR', [
			['u.user_name', 'like', '%' + text + '%'],
			['u.user_firstname', 'like', '%' + text + '%'],
			['u.user_lastname', 'like', '%' + text + '%']
		])
	}
}
